import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { nounClausesData, getDataForDifficulty } from '../courses/data/grammar/nounClauses';

export default function NounClauseTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : nounClausesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
